import { render } from "./SkeletonItem.vue?vue&type=template&id=2fd5c2b8&ts=true"
import script from "./SkeletonItem.vue?vue&type=script&lang=ts"
export * from "./SkeletonItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSkeleton});
